import { render } from "./payment-info.vue?vue&type=template&id=5d71d42c"
import script from "./payment-info.vue?vue&type=script&lang=js"
export * from "./payment-info.vue?vue&type=script&lang=js"

import "./payment-info.vue?vue&type=style&index=0&id=5d71d42c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__